import { useNavigate } from "react-router-dom";

const BRAND = "#FF6B35";

interface Props {
  item: {
    id: number;
    title?: string;
    name?: string;
    thumb?: string;
    pic?: string;
    short_title?: string;
  };
}

export function CateItem({ item }: Props) {
  const navigate = useNavigate();

  const handleCheckDetail = () => {
    navigate(`/workspace/edit-item/detail`, { state: { cateId: item.id } });
  };

  return (
    <div className="w-full flex items-center py-[15px] border-b border-gray-100/15">
      <img
        src={item.thumb || item.pic || ""}
        alt=""
        className="w-[60px] h-[60px] shrink-0 mr-[15px] rounded-xl object-cover bg-gray-100"
      />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-bold text-gray-900 truncate">{item.title || item.name}</p>
        {item.short_title && (
          <p className="text-xs text-gray-400 mt-1 line-clamp-2 leading-relaxed">{item.short_title}</p>
        )}
      </div>
      <button
        onClick={handleCheckDetail}
        className="ml-[10px] shrink-0 px-2.5 py-1 rounded-[4px] text-xs font-medium cursor-pointer active:scale-[0.98]"
        style={{ background: BRAND, color: "#fff" }}
      >
        申请
      </button>
    </div>
  );
}
